module.exports = __webpack_public_path__ + "img/product-9.9da3b5ca.jpg";